import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import { AmenityCreateReservation } from 'components/amenity-booking'
import NivosModal from 'components/nivos-modal'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
  }
}

type AppProps = StateProps & DispatchProps

const createData = (
  amenity: string,
  price: string
): { amenity: string, price: string } => {
  return { amenity, price }
}

const rows = [
  createData('Infinity Pool', '$40/hr'),
  createData('Gym', '$40/hr'),
  createData('Basketball Court', '$40/hr'),
  createData('Karaoke Room', '$40/hr'),
  createData('Game Room', '$40/hr')
]
const AmenityBookingFC: React.FC<any> = (props: AppProps) => {
  const { theme, layout } = props
  const [reservationModal, setOpen] = React.useState(false)

  return (
    <Box
      color={theme.secondaryColor}
      display={'flex'}
      flexDirection={'column'}
      width={1}
    >
      <NivosModal
        title={layout.language.translations.createReservation}
        open={reservationModal}
        setOpen={setOpen}
      >
        <AmenityCreateReservation selectedAmenity={{} as any} />
      </NivosModal>
      <Typography variant={'h3'} align={'center'}>
        {layout.language.translations.amenityBooking.toUpperCase()}
      </Typography>
      <Box display={'flex'} justifyContent={'space-evenly'} padding={1}>
        <TableContainer sx={{ width: 0.4 }}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Amenities</TableCell>
                <TableCell align="center">Price</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(row => (
                <TableRow
                  key={row.amenity}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.amenity}
                  </TableCell>
                  <TableCell align="center">{row.price}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          width={0.4}
        >
          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Amenities</TableCell>
                  <TableCell align="center">Price</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(row => (
                  <TableRow
                    key={row.amenity}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.amenity}
                    </TableCell>
                    <TableCell align="center">{row.price}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Button
            variant={'contained'}
            color={'primary'}
            onClick={() => setOpen(true)}
            fullWidth
            sx={{ marginTop: 3 }}
          >
            {layout.language.translations.createReservation.toUpperCase()}
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations
})

const AmenityBooking = connect(
  mapStateToProps,
  mapDispatchToProps
)(AmenityBookingFC)

export default AmenityBooking
